import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { SvgModule } from 'src/app/shared/svg/svg.module'
import { OldTabComponent } from './old-tab.component'
import { OldTabsComponent } from './old-tabs.component'

@NgModule({
  imports: [RouterModule, CommonModule, NgbDropdownModule, SvgModule],
  declarations: [OldTabComponent, OldTabsComponent],
  exports: [OldTabComponent, OldTabsComponent]
})
export class OldTabsModule {}
